import { Chip } from '@mui/material'
import React from 'react'
import { black, grey, shade } from '../../../colors'
import { getBarChartColors, getContrastTextColor } from './Charts/BarChart/helper'
import { useReportsContext } from '../ReportsContext'

interface ReportsChipProps {
  index: number
  label: string | number | JSX.Element
}

const ReportsChip: React.FC<ReportsChipProps> = ({ index, label }): JSX.Element => {
  const { selectedTrend } = useReportsContext()
  const barColors = getBarChartColors(selectedTrend)

  const getChipTextColor = (index: number): string => {
    const bgColor = barColors[index] ?? shade[650]
    return getContrastTextColor(bgColor, grey[0], black[100])
  }

  return (
    <Chip
      key={index}
      size="small"
      label={label}
      sx={{
        bgcolor: barColors[index] ?? shade[650],
        color: getChipTextColor(index),
        fontSize: '14px',
        lineHeight: 4,
        fontWeight: 500,
        borderRadius: 2.5,
        '& .MuiChip-label': {
          px: 2,
          py: 0
        }
      }}
    />
  )
}

export default ReportsChip
